/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI WL
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ChatbotResponseDepthLevel = {
    Low: 'Low',
    Medium: 'Medium',
    High: 'High',
    Expert: 'Expert'
} as const;
export type ChatbotResponseDepthLevel = typeof ChatbotResponseDepthLevel[keyof typeof ChatbotResponseDepthLevel];


export function instanceOfChatbotResponseDepthLevel(value: any): boolean {
    for (const key in ChatbotResponseDepthLevel) {
        if (Object.prototype.hasOwnProperty.call(ChatbotResponseDepthLevel, key)) {
            if (ChatbotResponseDepthLevel[key as keyof typeof ChatbotResponseDepthLevel] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ChatbotResponseDepthLevelFromJSON(json: any): ChatbotResponseDepthLevel {
    return ChatbotResponseDepthLevelFromJSONTyped(json, false);
}

export function ChatbotResponseDepthLevelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChatbotResponseDepthLevel {
    return json as ChatbotResponseDepthLevel;
}

export function ChatbotResponseDepthLevelToJSON(value?: ChatbotResponseDepthLevel | null): any {
    return value as any;
}

export function ChatbotResponseDepthLevelToJSONTyped(value: any, ignoreDiscriminator: boolean): ChatbotResponseDepthLevel {
    return value as ChatbotResponseDepthLevel;
}

